import { DatastoreProvider } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { storyFeaturesQueryOptions } from 'data/story-features';
import { type RoutePath, Slot, useLocalSearchParams } from 'expo-router';
import { SkeletonTeaserScreen } from 'structure/question/teaser-loading-screen';
import { articleModuleQuery } from 'system/structure-modules';

export function SuspenseFallback() {
    return <SkeletonTeaserScreen />;
}

export default function ArticleInstanceWidgetLayout() {
    const { siloKey, instanceKey: decodedInstanceKey } =
        useLocalSearchParams<Extract<RoutePath, `/[siloKey]/article/[instanceKey]${string}`>>();
    // Legacy routing code did not perform encoding/decoding of path parameters.
    // Article instance keys need to be re-encoded before use.
    const instanceKey = encodeURIComponent(decodedInstanceKey);
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'article',
        instanceKey,
        featuresSource: storyFeaturesQueryOptions,
        moduleQuery: articleModuleQuery,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <Slot />
        </DatastoreProvider>
    );
}
